import React from 'react';
import { numberWithComma } from 'src/utils/Utils';
import style from './ReportHealthInsuranceBonusTableRow.scss';

const ReportHealthInsuranceBonusTableRow = ({
  healthInsuranceInsuredPersonnelNumber,
  name,
  birthdayHuman,
  staffCode,
  totalBonus,
  currencyBonus,
  genbutsuBonus
}) => (
  <tr>
    <td>{staffCode}</td>
    <td>{healthInsuranceInsuredPersonnelNumber}</td>
    <td>{name}</td>
    <td>{birthdayHuman}</td>
    <td className={'td stepMoneyTd'}>
      <p className={style.twoStepTableRow}>{numberWithComma(currencyBonus)} 円</p>
      <p className={style.twoStepTableRow}>{numberWithComma(genbutsuBonus)} 円</p>
    </td>
    <td className={style.moneyTd}>{numberWithComma(totalBonus)} 千円</td>
    <td className={'td bikoTd '}>
      <p>1. 70歳以上被用者</p>
      <p>2. 二以上勤務</p>
      <p>3. 同一月内の賞与合算</p>
      <p> （初回　日）</p>
    </td>
  </tr>
);
export default ReportHealthInsuranceBonusTableRow;
